import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {

  constructor() { }

  get(key, fromLocal = true) {

    let value;

    if (!fromLocal) {
      value = sessionStorage.getItem(key);
    } else {
      value = localStorage.getItem(key);
    }

    if (!value) {
      return false;
    } else {
      return JSON.parse(JSON.stringify(value) || '{}');
    }

  }

  set(key, value, fromLocal = true) {
    
    if (value || value != undefined) {
      if (!fromLocal) {
        /** FIXME JSON.stringify have been deleted to make it work */
        sessionStorage.setItem(key, JSON.stringify(value));
      } else {
        localStorage.setItem(key, JSON.stringify(value));
      }
    }
  }

  remove(key, fromLocal = true) {
    if (!fromLocal) {
      sessionStorage.removeItem(key);
    } else {
      localStorage.removeItem(key);
    }
  }

  clear() {
    sessionStorage.clear();
  }

  attribute(key, fromLocal, attr){

    let obj;

    try{ 
      obj = JSON.parse(this.get(key, fromLocal));
      if(obj) return obj[attr];
    } catch(e) { 
      //Error
    }


    return obj;
  }

}
